export default __webpack_public_path__ + "6ef818181402f10fcc68a58a609b7aa9.woff";